import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { EntGovernment } from "../../../../models/handBooks/government";
import { useAddGovernmentMutation, useDeleteGovernmentMutation, useEditGovernmentMutation } from "../../../../redux/api/handBooksApi/governmentApi";
import { getCookie } from "typescript-cookie";

const useGovernment = (modal: any, refresh?: () => void) => {
    const { t } = useTranslation()
    const { confirm } = modal;
    const [addGovernment] = useAddGovernmentMutation();
    const [deleteGovernment] = useDeleteGovernmentMutation();
    const [editGovernment] = useEditGovernmentMutation();


    async function onAddGovernment(newGovernment: EntGovernment): Promise<boolean> {
        try {
            let status: boolean = false;
            await addGovernment(newGovernment).then((response: any) => {
              if (response.error !== undefined) {
                              const isKyrgyz = getCookie('i18next') === 'ky';
                              const lang = isKyrgyz ? 'kg' : 'ru';
                              const res = response.error.data?.res;
                              const errorMessages = Array.isArray(res)
                                  ? res.map((error: any) => error[lang] || error.ru).join('\n')
                                  : response.error.data?.msg || t('unknownError'); 
                              throw new Error(errorMessages);
                          }
                if (response.data.success) {
                    status = true;
                    message.success(t('msg.successAdd'));
                    if(refresh) refresh();
                }
            }).catch((error:any) => {
                modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            modal.error({ title: t('msg.error'), content: String(error.message) });
            return false;
        }
    }

    async function onDeleteGovernment(government: EntGovernment) {
        try {
            let status: boolean = false;
            confirm({
                centered: true,
                title: t('msg.confirmDeleteText'),
                okText: t('general.yes'),
                cancelText: t('general.no'),
                onOk() {
                    deleteGovernment(government.id as number).then((response: any) => {
                        if (response.error !== undefined && response.error.status === 400) {
                            status = false;
                            throw new Error(response.error.data.message);
                        }
                        if (response.data.success) {
                            status = true;
                            Modal.success({title: t('msg.successDelete')});
                            if(refresh) refresh();
                        }
                    }).catch((error: any) => {
                        Modal.error({ title: t('msg.error'), content: String(error.message) });
                    });
                }
            })
            return status
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    async function onEditGovernment(editedGovernment: EntGovernment): Promise<boolean> {
        try {
            let status: boolean = false;
            await editGovernment(editedGovernment).then((response: any) => {
                if (response.error !== undefined) {
                    const isKyrgyz = getCookie('i18next') === 'ky';
                    const lang = isKyrgyz ? 'kg' : 'ru';
                    const res = response.error.data?.res;
                    const errorMessages = Array.isArray(res)
                        ? res.map((error: any) => error[lang] || error.ru).join('\n')
                        : response.error.data?.msg || t('unknownError'); 
                    throw new Error(errorMessages);
                }
                if (response.data.success) {
                    status = true;
                    Modal.success({title: t('msg.successEdited')});
                    if(refresh) refresh();
                }
            }).catch((error: any) => {
                Modal.error({ title: t('msg.error'), content: String(error.message) });
            });
            return status;
        } catch (error: any) {
            Modal.error({ title: t("msg.error"), content: String(error.message) });
            return false;
        }
    };

    return { onAddGovernment, onDeleteGovernment, onEditGovernment }
}

export { useGovernment };
